<script>
  import { quest } from "../taskTipStore.js";
  import { writable } from "../localStorageStore.js";

  import Icon from "fa-svelte";
  import { faCheckSquare } from "@fortawesome/free-solid-svg-icons/faCheckSquare";
  import { faCircle } from "@fortawesome/free-solid-svg-icons/faCircle";
  import { toHSL, debounce, getRandomBackgroundColor, adjustColor } from "../util.js";

  import AdminQuests from "./AdminQuests.svelte";
  import PlantUml from "./PlantUml.svelte";
  import Monaco from "../Monaco.svelte";
import Modal from "../Modal.svelte";  

  console.log('AdminPage');

  if (!Object.values) Object.values = o => Object.keys(o).map(k => o[k]);

  $: someTestJSON = JSON.stringify($quest, null, 2);

  let currentTaskId;
  $: currentTask = $quest.tasks.find(
    task => task.id == currentTaskId
  );
  let contenteditable = false;

  export const preferences = writable("adminPreferences", {
    theme: "dark",
    pane: "50%" //,
  });

  // if ($preferences.currentTaskId == undefined) {
  //   $preferences.currentTip = -1;
  //   $preferences.currentTaskId = -1;
  //   $preferences.availableTasks = [6];
  // }

let editorLoadedVar = false;
let promise = Promise.resolve([]);
let showModalCheckResult = false;

  let firstContentChanged;
  let showEditor = false;

  function toggleEditor(event) {
    showEditor = !showEditor;
    if (!showEditor && event) {
      console.log('saved');
      let mainCode = event.detail.mainCode;
      let junit = event.detail.junit;
      currentTask.javacodeFileMainDecision = mainCode;
      currentTask.junit = junit;
      quest.updateTask(currentTask);
      // if (code) saveCodeInLocalStorage(code);
    }
    // if (showEditor) {
    //   // console.log('try processingcode: ' + $user.currentTask.processingcode);
    //   // console.log('try javacodeFileMain: ' + $user.currentTask.javacodeFileMain);
    //   if (currentTask && currentTask.processingcode && !firstContentChanged) {
    //       processingcode = currentTask.processingcode;
    //       // window.editor.setValue($user.currentTask.processingcode);
    //   } else {
    //     processingcode = "";
    //   }

    //   if (currentTask && currentTask.javacodeFileMain && !firstContentChanged) {
    //       javacodeFileMain = currentTask.javacodeFileMain;
    //       // window.editor.setValue($user.currentTask.processingcode);
    //   } else {
    //     javacodeFileMain = "";
    //   }        
    // }
  }  

// CHECK CODE
  async function fetchCheckCode() {
    // let code = window.editor.getValue();
    let code = currentTask.javacodeFileMainDecision;
    let junit = currentTask.junit;

    const response = await fetch("https://onlineju.herokuapp.com/api/v2/ju/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        files: [{
            name: "Main",
            content: code
            }],
        junit: junit
      })
    });

    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        "Упс, ошибка :( Похоже сервер не доступен. \nПопробуйте позже"
      );
    }
  }  

async function checkCode(event) {
  if (!currentTask.id) return; // не подгрузилась задача
  if (event) {
    console.log('checkCode');
    let mainCode = event.detail.mainCode;
    let junit = event.detail.junit;
    currentTask.javacodeFileMainDecision = mainCode;
    currentTask.junit = junit;
    quest.updateTask(currentTask);
  }
  window.editor.getAction('editor.action.formatDocument').run()
      .then(async () => {
      promise = fetchCheckCode();
      showModalCheckResult = true;
      let res = await promise;
      console.log(JSON.stringify(res, null, 2))
      // if (res) saveCodeInLocalStorage(window.editor.getValue());
      // if (res) postResultToDB(res);
  });
}

async function closeModalCheckResult() {
  showModalCheckResult = false;
  // let res = await promise;
  // if (res.ok) {
  //   // closeTaskWindow();      
  //   switch (task.button) {
  //     case "check":
  //       setTaskCheck();
  //       break;
  //     case "stop":
  //       setTaskCheck();
  //       break;
  //     case "done":
  //       setTaskDone();
  //       break;
  //     default:
  //       alert('Task type error');
  //   }      
  // }  
}

  function addTipForCurrentTask(i) {
    let t = currentTask;
    if (t.tips) {
      if (t.tips.includes(i)) {
        t.tips = t.tips.filter(e => e != i);
      } else {
        t.tips = [...t.tips, i];
      }
    } else {
      t.tips = [i];
    }
    quest.updateTask(t);
  }

  function addTaskForCurrentTask_old(i) {
    let t = currentTask;    
    // если это первая задача
    // todo (добавить ее и пользователю в available)

    if (!t) { // если текущая задача не выделена
      // if (!$quest.startTask) { // если это первая задача в квесте
      if ($quest.tasks.length <= 1) { // если это первая задача в квесте
        quest.setQuestStartTask(i);
      } // иначе ничего не делать
    } else { // если выделена задача
      if (i == t.id) { // если попытались кликнуть на самой себя
        // запретить добавлять саму себя
        quest.setQuestStartTask(i); // назначить эту задачу стартовой
        return; 
      }
      if (t.next) { // у задачи уже есть следующие задачи 
        if (t.next.includes(i)) { // и эта задача в них 
          t.next = t.next.filter(e => e != i); // исключить
        } else { // но этой задачи нет
          t.next = [...t.next, i]; // добавить
        }
      } else { // нет следующих
        t.next = [i]; // добавить первую в список
      }
      quest.updateTask(t);
    }
  }

    function addTaskForCurrentTask(newTask) {
    let t = currentTask;    

    // если НЕ выделена задача или если попытались кликнуть на самой себя   // запретить добавлять саму себя
    if (!t || t.id == newTask.id) { 
      return;
    }

    if (newTask.prev) { // у задачи уже есть предыдущие задачи 
      if (newTask.prev.includes(t.id)) { // и эта задача в них 
        newTask.prev = newTask.prev.filter(e => e != t.id); // исключить
      } else { // но этой задачи нет
        newTask.prev = [...newTask.prev, t.id]; // добавить
      }
    } else { // нет предыдущих
      newTask.prev = [t.id]; // добавить первую в список
    }
    quest.updateTask(newTask);
  }

  function addNewTask() {
    console.log(quest.getQuestId());
    
    if (!quest.getQuestId()) return;
    let newTask = {
      name: "newTaskTheme",
      next: [],
      prev: [], //currentTaskId ? [currentTaskId] : [],
      tips: [],
      button: "check",
      type: "processing",
      whenprev: "or",
      bgcolor: getRandomBackgroundColor(),
      score: Math.round(10 + Math.random() * 20)//,
      // id: Math.round(Math.random() * 1000000)
    };
    newTask.id = quest.addTask(newTask);
    addTaskForCurrentTask(newTask);
    currentTaskId = newTask.id;

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  function doubleCurrentTask() {
    console.log(quest.getQuestId());
    
    if (!quest.getQuestId()) return;
    let newTask = {
      name: "newTaskTheme",
      next: [],
      prev: [], //currentTaskId ? [currentTaskId] : [],
      tips: [],
      button: currentTask.button,
      type: currentTask.type,
      whenprev: currentTask.whenprev,
      bgcolor: getRandomBackgroundColor(),
      score: Math.round(10 + Math.random() * 20),
      junit: currentTask.junit,
      javacodeFileMainDecision: currentTask.javacodeFileMainDecision,
      javacodeFileMain: currentTask.javacodeFileMain,
      processingcode: currentTask.processingcode,
      desc: currentTask.desc
    };
    newTask.id = quest.addTask(newTask);
    addTaskForCurrentTask(newTask);
    currentTaskId = newTask.id;

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }  

  function addNewTip() {
    let newTip = {
      name: "newTipTheme"//,
      // id: Math.round(Math.random() * 1000000)
    };
    newTip.id = quest.addTip(newTip);
    addTipForCurrentTask(newTip.id);
    $preferences.currentTip = newTip.id;
  }
</script>

<style>
  .main {
    text-align: center;
    padding: 1em;
    max-width: 840px;
    max-width: 1040px;
    margin: 0 auto;
    top: 0px;
  }

  h2 {
    margin: 0;
  }

  h3 {
    margin: 0;
    text-transform: uppercase;
    font-weight: 100;
    color: #ccc;
  }

  .card.task {
    /* background-color: burlywood; */
    background-color: #fff;
  }

  .current {
    /* background-color: burlywood !important; */
    /* background-color: #fff; */
    /* border: 3px !important; */
    color: red !important;
    font-weight: bold;
  }

  .card.task.done {
    /* background-color: rgb(0, 163, 0); */
    background-color: #eee;
    /* color: #bbb; */
    box-shadow: none;
    color: transparent;
    text-shadow: 0 0 0 #bbb;
  }

  .card.task.check {
    /* background-color: hsl(143, 41%, 90%); */
    /* color: hsl(143, 34%, 54%); */
    background-color: #fff;
    /* color: #bbb; */
    color: transparent;
    text-shadow: 0 0 0 #bbb;
  }

  .card.task.inaccessible {
    /* background-color: #eee; */
    background-color: #fff;
    /* color: #ddd; */
    box-shadow: none;
    border: dotted #bbb 1px;
    color: transparent;
    text-shadow: 0 0 0 #ddd;
  }

  .card.tip {
    background-color: hsl(300, 100%, 27%);
    color: hsl(300, 100%, 67%);
  }

  .card.tip.short {
    color: #fff;
  }

  .card.task.viewed {
    color: #888;
    background-color: #ddd !important;
  }

  .card.tip.short.viewed {
    color: #eee;
    background-color: #aaa;
  }

  .card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    /* transition: 0.8s; */
    transition: all 0.3s;
    display: inline-block;
    vertical-align: top;
    margin: 10px;
    max-width: 200px;
    padding: 15px;
    border-radius: 10px;
    position: relative;
    color: #fff;
  }

  .card.expanded {
    width: 100%;
    /* height: 100%; */
    position: relative;
    top: 0;
    margin-top: 0;
    left: 0;
    margin-left: 0;
    border-radius: 0;
    /* max-width: 60%; */
    max-width: 70%;
    /* border-radius: 20px; */
    border-radius: 20px 0px 20px 20px;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.5);
  }

  /* On mouse-over, add a deeper shadow */
  .card:hover:not(.expanded):not(.tip):not(.inaccessible) {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
    /* border-style: dashed; */
    /* background-color: #eeeeaa */
    /* background: burlywood; */
  }

  :global(.card.task.expanded) {
    /* background: burlywood; */
    /* height: 300px; */
    /* background: #0f0; */
  }
  :global(.card.tip.expanded) {
    background: #fff;
    /* height: 500px; */
  }

  /* Add some padding inside the card container */
  .container {
    /* padding: 2px 16px; */
    padding: 2px;
  }

  :global(.container.bold) {
    font-weight: bold;
    text-transform: uppercase;
    /* color: #aaa; */
    /* color: #333; */
    color: #fff;
  }

  button.playground {
    background-color: coral;
    border: 0;
    padding: 10px;
    margin: 30px;
    border-radius: 5px;
    color: #fff;
    text-transform: uppercase;
  }

  button.done {
    /* background-color: green; */
    background-color: orange;
    border: 0;
    padding: 10px;
    margin: 30px;
    /* border-radius: 5px; */
    border-radius: 0 0 20px 20px;
    color: #fff;
    text-transform: uppercase;
    position: absolute;
    right: -30px;
    bottom: -30px;
    width: 100%;
    /* width: 70%; */
    /* bottom: 0px; */
  }

  button.check {
    background-color: green;
    border: 0;
    padding: 10px;
    margin: 30px;
    border-radius: 0 0 20px 20px;
    color: #fff;
    text-transform: uppercase;
    position: absolute;
    right: -30px;
    bottom: -30px;
    width: 100%;
  }

  button.cancel {
    /* background-color: green; */
    background-color: orange;
    border: 0;
    padding: 10px;
    margin: 30px;
    /* border-radius: 5px; */
    border-radius: 0 0 20px 20px;
    color: #fff;
    text-transform: uppercase;
    position: absolute;
    /* right: -30px; */
    left: -30px;
    bottom: -30px;
    width: 20%;
    /* bottom: 0px; */
  }

  button.close-task {
    /* background-color: green; */
    background-color: hsl(39, 60%, 80%);
    border: 0;
    padding: 10px;
    margin: 30px;
    /* border-radius: 5px; */
    border-radius: 0 0 20px 20px;
    color: #fff;
    text-transform: uppercase;
    position: absolute;
    /* right: -30px; */
    right: -30px;
    top: -30px;
    /* width: 20%; */
    /* bottom: 0px; */
  }

  button.hidden {
    visibility: hidden;
    /* display: none; */
  }

  /* [contenteditable] { */
  .contenteditable {
    padding: 0.5em;
    border: 1px solid #eee;
    border-radius: 4px;
  }

  /* The Modal (background) */
  .modal {
    display: hidden; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    padding-top: 100px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  .noty_close_button2 {
    position: absolute;
    top: 2px;
    right: 2px;
    /* font-weight: 700; */
    width: 20px;
    height: 20px;
    text-align: center;
    /* line-height: 20px; */
    /* background-color: rgba(0, 0, 0, 0.05); */
    border-radius: 2px;
    cursor: pointer;
    -webkit-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
    /* exp */
    display: block;
    box-sizing: border-box;
    font-family: "Nunito Sans", "Avenir Next", "Segoe UI", "Open Sans",
      "Helvetica Neue", Helvetica, Arial, sans-serif;
    opacity: 0.3;
    font-weight: 600;
    text-shadow: none;
    font-size: 21px;
    line-height: 1;
    color: #000;
    background: 0 0;
  }

  .row {
    display: flex;
    box-sizing: border-box;
  }

  /* Create two equal columns that sits next to each other */
  .column {
    flex: 50%;
    padding: 10px;
    box-sizing: border-box;
    /* Should be removed. Only for demonstration */
    /* height: 300px;  */
  }

  .column.two {
    flex: 100%;
    padding: 10px;
    box-sizing: border-box;
    text-align: left;
  }  

  .field {
    border: 1px dotted grey;
  }  
</style>

<div class="main">
  <h2>Admin</h2>
  <AdminQuests />
  <br />
  <!-- <PlantUml quest={$quest} /> -->
  <label>
    <input type="checkbox" bind:checked={contenteditable} />
    contenteditable
  </label>
  {#each $quest.tasks as task, i (task.id)}
    {#if currentTaskId === task.id || currentTaskId == undefined}
        <!-- on:focusout={()=> {if (task._changed || !task._changed) {task._changed = false; quest.updateTask(task)}}} -->
      <div
        class="card task"
        on:click={() => {
          currentTaskId = currentTaskId == undefined ? task.id : currentTaskId;
        }}
        class:expanded={currentTaskId === task.id}
        on:focusout={()=> {quest.updateTask(task)}}
        style="background-color: {task.bgcolor || toHSL(task.name)}">        
            <!-- bind:innerHTML={task.name} -->
            <!-- on:input={()=> {quest.updateTask(task)}} -->
            <!-- on:input={()=> {task._changed = true}} -->
        {#if currentTaskId != task.id}
          <div class="container" style="color: #fff">{task.name}</div>
        {/if}
        <!-- {#if $quest.startTask == task.id}(start){/if}         -->
        {#if currentTaskId === task.id}
          <div
            class="container bold"
            class:bold={currentTaskId === task.id}>          
            <div
              contenteditable="true"
              class:contenteditable
              style="color: #fff"
              bind:textContent={task.name}
              on:click|stopPropagation={() => {}} />
          </div>        
          <br />
          <div style="text-align: left">
            <!-- on:input={()=> {quest.updateTask(task)}} -->
            <!-- on:input={()=> {task._changed = true}} -->
            <!-- bind:textContent={task.desc} /> -->
          <div
            contenteditable="true"
            class:contenteditable
            bind:innerHTML={task.desc} />
          </div>
          <button
            class="close-task"
            on:click|preventDefault|stopPropagation={() => {
              currentTaskId = currentTaskId === task.id ? undefined : task.id;
            }}>
            <!-- <Icon class="myClass1 myClass2" icon={faCheckSquare} /> -->
            X
          </button>
          {#if !contenteditable}
            <!-- <label><input type="checkbox" bind:checked={task.processing} />processing</label>         -->

            <br><br>
            <div style="text-align: left">
              <label>
                <input type=radio bind:group={task.type} value={'processing'} on:change={()=> {console.log('ch'); quest.updateTask(task)}}>
                processing
              </label>
              <label>
                <input type=radio bind:group={task.type} value={'java'} on:change={()=> {console.log('ch'); quest.updateTask(task)}}>
                java
              </label>

              <br>
              <b>Что делать с задачей:</b>
              <label>
                <input type=radio bind:group={task.button} value={'check'} on:change={()=> {console.log('ch'); quest.updateTask(task)}}>
                отправлять на проверку (и открывать следующие)
              </label>

              <label>
                <input type=radio bind:group={task.button} value={'stop'} on:change={()=> {console.log('ch'); quest.updateTask(task)}}>
                стоп-задача (не открывать другие, пока эта не принята)
              </label>                  

              <label>
                <input type=radio bind:group={task.button} value={'done'} on:change={()=> {console.log('ch'); quest.updateTask(task)}}>
                сразу засчитывать выполненным
              </label>       

              <br>
              <b>Для открытия задачи должны быть открыты</b>
              <label>
                <input type=radio bind:group={task.whenprev} value={'and'} on:change={()=> {console.log('and'); quest.updateTask(task)}}>
                Все предыдущие (И)
              </label>
              <label>
                <input type=radio bind:group={task.whenprev} value={'or'} on:change={()=> {console.log('or'); quest.updateTask(task)}}>
                Хоть одна из предыдущих (ИЛИ)
              </label>                        

              <input bind:value={currentTask.bgcolor}>
              <button on:click|preventDefault|stopPropagation={() => {
                  currentTask.bgcolor = getRandomBackgroundColor();
                  quest.updateTask(currentTask);
                }}>
              Change background</button>

              <button on:click|preventDefault|stopPropagation={() => {currentTask.bgcolor = adjustColor(currentTask.bgcolor, "l", +5);}}>l+</button>
              <button on:click|preventDefault|stopPropagation={() => {currentTask.bgcolor = adjustColor(currentTask.bgcolor, "l", -5);}}>l-</button>
              <button on:click|preventDefault|stopPropagation={() => {currentTask.bgcolor = adjustColor(currentTask.bgcolor, "s", +5);}}>s+</button>
              <button on:click|preventDefault|stopPropagation={() => {currentTask.bgcolor = adjustColor(currentTask.bgcolor, "s", -5);}}>s-</button>
            </div>
            
            <button
              class="playground"
              on:click|preventDefault|stopPropagation={toggleEditor}>
              ☕️Открыть редактор кода
            </button>            

            {#if (task.type == "java")}
              <div style="text-align: left">
                Java pre-code:<br>
                <pre
                  class="field"
                  contenteditable="true"
                  bind:textContent={currentTask.javacodeFileMain} />
                <br>
                <!-- Java decision code:<br>
                <pre
                  class="field"
                  contenteditable="true"
                  bind:textContent={currentTask.javacodeFileMainDecision} />
                <br>                
                JUnit: <button class="log" on:click={()=>{console.log(currentTask.junit)}}>log</button><br>
                <pre style="height: 400px;overflow:scroll;"
                  class="field"
                  contenteditable="true"
                  bind:textContent={currentTask.junit} />
                <br />      -->
              </div>
            {/if}

            {#if (task.type == "processing")}
              <div style="text-align: left">
                Processing pre-code:<br>
                <pre
                  class="field"
                  contenteditable="true"
                  bind:textContent={currentTask.processingcode} />
                <br />     
              </div>
            {/if}
            <!-- <label><input type="checkbox" bind:checked={task.button_check} />отправить на проверку</label>           -->
            <!-- <label><input type="checkbox" bind:checked={task.button_done} />задание выполнено</label>           -->
            <br />
            <br />
            <!-- <button
              class="check"
              on:click|preventDefault|stopPropagation={() => {
                $quest.tasks = $quest.tasks;
              }}>
              <Icon class="myClass1 myClass2" icon={faCheckSquare} />
              Отправить задачу на проверку
            </button> -->
          {/if}
        {/if}
      </div>
    {/if}
  {/each}

  <br />
  {#if $quest.id}
    <button
      class="card task"
      style="background-color: #f2a; position: fixed"
      class:hidden={currentTaskId != undefined}
      on:click|preventDefault|stopPropagation={() => {
        addNewTask();
      }}>
      + Задача
    </button>
  {/if}

  <div>
    <div class="row">
      {#if currentTaskId != undefined}
        <div class="column">
          <h2>Подсказки</h2>
          {#each $quest.tips as tip, i (tip.id)}
            {#if $preferences.currentTip != tip.id}
              <div
                class="card tip short"
                class:viewed={currentTask && (!currentTask.tips || currentTask.tips && !currentTask.tips.includes(tip.id))}                
                on:click={() => {
                  $preferences.currentTip = $preferences.currentTip === tip.id ? -1 : tip.id;
                }}>
                <div
                  class="container bold"
                  class:bold={$preferences.currentTip === tip.id}>
                  <div>{tip.name}</div>
                </div>
                <button
                  class="close-task"
                  on:click|preventDefault|stopPropagation={() => {
                    addTipForCurrentTask(tip.id);
                  }}>
                  +
                </button>
              </div>
            {:else}
              <!-- if (tip._changed || !tip._changed) {
                tip._changed = false; 
              } -->
              <div
                id="myModal"
                class="modal"
                on:focusout={()=> {quest.updateTip(tip)}}
                on:click={() => {
                  $preferences.currentTip = $preferences.currentTip === tip.id ? -1 : tip.id;
                }}>
                <div
                  class="card tip"
                  on:click|preventDefault|stopPropagation={() => {}}
                  class:expanded={$preferences.currentTip === tip.id}>
                  <i class="fas fa-book" />
                  <div
                    class="container bold"
                    class:bold={$preferences.currentTip === tip.id}>
                      <!-- on:input={()=> {quest.updateTip(tip)}} -->
                    <div
                      contenteditable="true"
                      class:contenteditable
                      bind:textContent={tip.name} />
                  </div>
                  {#if $preferences.currentTip === tip.id}
                    <div style="text-align: left">                
                        <!-- on:input={()=> {quest.updateTip(tip)}} -->
                        <!-- bind:textContent={tip.desc} /> -->
                      Описание:
                      <div
                        contenteditable="true"
                        class:contenteditable
                        bind:innerHTML={tip.desc} />
                    </div>
                    <br />
                    Wistia:
                    <div
                      contenteditable="true"
                      class:contenteditable
                      bind:textContent={tip.wistia} />
                    <br />
                      <!-- src="https://fast.wistia.net/embed/iframe/1qya69feuu?fullscreenButton=true" -->
                    {#if tip.wistia}
                      <iframe
                        src="https://fast.wistia.net/embed/iframe/{tip.wistia}?fullscreenButton=true&autoPlay=true"
                        allowfullscreen
                        mozallowfullscreen
                        webkitallowfullscreen
                        oallowfullscreen
                        msallowfullscreen
                        style="border: none; width: 500px; height: 250px;"
                        title="some" />
                    {/if}
                    VoiceCodeCast:
                    <div
                      contenteditable="true"
                      class:contenteditable
                      bind:textContent={tip.voiceCodeCast} />
                    <br>
                    {#if tip.voiceCodeCast}
                      <iframe
                        src="{'https://khasang-codereview.vercel.app?' + tip.voiceCodeCast}"
                        allowfullscreen
                        mozallowfullscreen
                        webkitallowfullscreen
                        oallowfullscreen
                        msallowfullscreen
                        style="border: none; width: 800px; height: 650px;"
                        title="voiceCodeCast" />
                    {/if}                    
                    <button
                      class="close-task"
                      on:click|preventDefault|stopPropagation={() => {
                        $preferences.currentTip = $preferences.currentTip === tip.id ? -1 : tip.id;
                      }}>
                      X
                    </button>
                  {/if}
                </div>
              </div>
            {/if}
          {/each}

          <br />
          {#if $quest.id}
            <button
              class="card task"
              style="background-color: #f2a;"
              on:click|preventDefault|stopPropagation={() => {
                addNewTip();
              }}>
              + Подсказка
            </button>
          {/if}

        </div>
        <div class="column">
          <h2>Задачи</h2>
          {#each $quest.tasks as task, i (task.id)}
              <!-- class:viewed={currentTask && (!currentTask.next || currentTask.next && !currentTask.next.includes(task.id))} -->
            <div
              class="card task"
              class:viewed={!task.prev || task.prev && !task.prev.includes(currentTaskId)}
              class:current={currentTaskId == task.id}
              on:click={() => {
                currentTaskId = task.id;
              }}
              style="background-color: {task.bgcolor || toHSL(task.name)}">
              <div class="container">{task.name}</div>
              <button
                class="close-task"
                on:click|preventDefault|stopPropagation={() => {
                  addTaskForCurrentTask(task);
                }}>
                +
              </button>
            </div>
          {/each}
          <br />
          {#if $quest.id}
            <button
              class="card task"
              style="background-color: #f2a;"
              on:click|preventDefault|stopPropagation={() => {
                addNewTask();
              }}>
              + НОВАЯ ЗАДАЧА
            </button>
            {#if currentTask}
              <br>
              <button
                class="card task"
                style="background-color: #f2a;"
                on:click|preventDefault|stopPropagation={() => {
                  doubleCurrentTask();
                }}>
                + ДУБЛИРОВАТЬ ЗАДАЧУ
              </button>              
            {/if}
          {/if}
        </div>
      {/if}
    </div>

<div class="row">
  <div class="column two">
    <PlantUml quest={$quest} />

    <div style="text-align: left"><pre>
    {@html someTestJSON}
    </pre></div>
  </div>
</div>

  </div>
</div>
<!-- <br />
<PlantUml quest={$quest} /> -->

{#if showEditor}
  <span style="text-align:left">
      <!-- on:loaded={editorLoaded} 
      on:submitSketch={submitSketch}
      {processingcode} -->
      <!-- bind:taskDone={currentTask.done}
      bind:taskCheck={currentTask.check} -->
    <Monaco on:close={toggleEditor} 
      bind:firstContentChanged={firstContentChanged}
      bind:javacodeFileMain={currentTask.javacodeFileMainDecision}
      bind:processingcode={currentTask.processingcode}
      bind:type={currentTask.type}
      on:checkCode={checkCode}
      bind:task={currentTask}
      fromAdmin={true}
      />
      <!-- processing=currentTask.processing/> -->
    <!-- {#if !editorLoadedVar}
      <div class="editorLoading">
      <div style="text-align: center; vertical-align: middle; height: 100%">Редактор загружается... </div>
      </div>
    {/if}   -->
  </span>
{/if}

{#if showModalCheckResult}
<Modal on:close={async () => closeModalCheckResult()}>
    {#await promise}
      <p>...waiting</p>
    {:then result}
        {#if result.ok}
          <h2><span style="color: #109520">✅ЗАДАЧА ВЫПОЛНЕНА</span></h2>
            Количество тестов: {result.testCount}<br>
            Пройдено тестов: {result.testCount - result.testFailed}<br>          
        {:else}
            {#if result.testCodeFailed}
              <h2><span style="color: #2f2090">💤Ошибка на стороне сервера</span></h2>
                Напишите, плз, в чат преподавателю<br>или на саппорт support@khasang.io
            {:else}
                <h2><span style="color: #ff0000">ЗАДАЧА ПОКА НЕ ВЫПОЛНЕНА</span></h2>
                {#if result.compileOutput}
                    <b>Результат компиляции:</b><br><br>
                    <span style="text-align: left">
                      <pre class="compileOutput">{result.compileOutput}</pre>
                      <pre class="compileOutput">{result.failureMessages}</pre>
                    </span>
                {:else}
                    Количество тестов: {result.testCount}<br>
                    Провалено тестов: {result.testFailed}<br>
                    <br>
                    {#if result.failureMessages}<b>Сообщения об ошибках:</b><br><pre>{result.failureMessages}</pre><br>{/if}
                {/if}          
            {/if}          
        {/if}

    {:catch error}
      <p style="color: red">{error.message}</p>
    {/await}
  </Modal>
{/if}

<!-- <div style="clear: both; display: block;  box-sizing: border-box;"></div> -->
